<template>
  <div
    class="d-flex align-items-center justify-content-between position-relative"
    id="chartdiv"
    style="width: 100%; height: 250px"
  >
    <loader class="position-absolute w-100" v-show="pageLoader"></loader>
    <no-data
      class="position-absolute w-100"
      v-show="!revenueReport.length"
    ></no-data>
  </div>
</template>
<script>
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import tradingMixins from "@/plugins/trading";
import moment from "moment";

export default {
  mixins: [tradingMixins],
  data() {
    return {
      pageLoader: false,
      root: {},
    };
  },
  watch: {
    revenueReport(val) {
      setTimeout(() => {
        am5.ready(() => {
          this.createChart(val);
        });
      }, 200);
    },
  },
  methods: {
    createChart(dataArray) {
      let data = JSON.parse(JSON.stringify(dataArray));
      data.map((i) => {
        i.date = moment(i.date, "DD-MM-YYYY").valueOf();
        i.value = i.value && !isNaN(i.value) ? parseInt(i.value) : 0;
      });
      if ("dom" in this.root) this.root.dispose();
      this.root = am5.Root.new("chartdiv");
      var chart = this.root.container.children.push(
        am5xy.XYChart.new(this.root, {
          panX: false,
          panY: false,
          wheelX: "none",
          wheelY: "none",
          maxTooltipDistance: -1,
          pinchZoomX: true,
        })
      );

      chart
        .get("colors")
        .set("colors", [
          am5.color("#0181a8"),
          am5.color("#f36363"),
          am5.color("#40b37e"),
          am5.color("#b5529d"),
          am5.color("#fbb041"),
        ]);
      var xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(this.root, {
          maxDeviation: 0.2,
          baseInterval: {
            timeUnit: "day",
            count: 1,
          },
          renderer: am5xy.AxisRendererX.new(this.root, {}),
          tooltip: am5.Tooltip.new(this.root, {}),
        })
      );

      var yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(this.root, {
          renderer: am5xy.AxisRendererY.new(this.root, {}),
        })
      );
      xAxis.get("renderer").grid.template.setAll({
        strokeWidth: 0,
        strokeOpacity: 0,
      });
      yAxis.get("renderer").grid.template.setAll({
        strokeWidth: 0,
        strokeOpacity: 0,
      });

      var series = chart.series.push(
        am5xy.ColumnSeries.new(this.root, {
          name: `Deposit Volume`,
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "value",
          valueXField: "date",
          legendValueText: "{valueY}",
          // tooltip: am5.Tooltip.new(this.root, {
          //   pointerOrientation: "down",
          //   labelText: "{valueY}",
          // }),
        })
      );
      series.columns.template.setAll({
        tooltipX: am5.percent(50),
        tooltipY: am5.percent(0),
        tooltipText: "{valueY}",
      });
      series.data.setAll(data);
      series.appear();
      var cursor = chart.set(
        "cursor",
        am5xy.XYCursor.new(this.root, {
          behavior: "none",
        })
      );
      cursor.lineY.set("visible", false);
      this.pageLoader = false;
      chart.appear(1000, 100);
    },
    getRevenueReport() {
      this._runRevenueReport({
        globalParams: {},
        localParams: { parameter: this },
      });
    },
  },
  created() {
    if (this.revenueReport.length) {
      setTimeout(() => {
        am5.ready(() => {
          this.createChart(this.revenueReport);
        });
      }, 200);
    } else {
      this.pageLoader = true;
      this.getRevenueReport();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/shared/chart/revenueChart.vue